module.exports = __webpack_public_path__ + "static/media/postgresql.58ecff98.svg";